import { combineReducers } from 'redux'
import metaReducer from "./metaReducer";
import reducersgazeta from "../reducersgazeta";

const rootReducer = combineReducers({
    meta: metaReducer,
    gazeta: reducersgazeta
});
export default rootReducer